import React, { useEffect, useState } from "react";
import DrillDown from "../component/drillDown";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as lmsReportAction from "../../../../redux/actions/lmsReportAction";
import { getFormatedDate } from "../../../../utils/helper";
import { useSelector } from "react-redux";
import Loader from "../../../../library/common/Loader";
import * as lmsAction from "../../../../redux/actions/lmsAction";
import * as toolboxAction from "../../../../redux/actions/toolBoxAction";
import { toast, ToastContainer } from "react-toastify";
import { PAGE_SIZE_500 } from "../../../../constant/constant";
const DrillDownContainer = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const page = location?.state?.page;
  const apiData = location?.state?.apiData;
  const [selectedCard, setselectedCard] = useState(apiData?.card);
  const [typeselectdata, setTypeselectdata] = useState(() =>
    Array.isArray(location?.state?.typeselectdata)
      ? location.state.typeselectdata
      : [],
  );
  const [emailSendStatus, setEmailSendStatus] = useState(null);

  useEffect(() => {
    dataClear();
  }, []);

  const getLmsDashboardReportDetails = useSelector(
    (state) => state.getLmsDashboardReportDetails,
  );

  const getLMSDashboardReport = useSelector(
    (state) => state.getLmsDashboardReport,
  );
  function getMoretDetails(data) {
    if (data?.isSendMail) {
      setEmailSendStatus(true);
    } else {
      setEmailSendStatus(false);
    }
    dispatch(lmsReportAction.getLmsDashboardReportDetails(data));
  }

  const getLmsDashboardReportData = (data) => {
    dispatch(lmsReportAction.getLmsDashboardReport(data));
    dispatch(lmsReportAction.clearDashboardDetails(data));
  };

  useEffect(() => {
    dispatch(lmsAction.getAssignedListClear());
    dispatch(lmsAction.getAssignedLessonListClear());
    dispatch(toolboxAction.scheduleUserCountStatusClear());
  }, []);

  useEffect(() => {
    if (page === "completedTraining") {
      const data = {
        startDate: getFormatedDate(apiData.startDate),
        endDate: getFormatedDate(apiData.endDate),
        divisionId:
          apiData.divisionId === "AllDivision" ? 0 : apiData.divisionId,
      };
      getLmsDashboardReportData(data);
    }
  }, []);
  const TRAINING_WITH_LOWEST_PARTICIPATION_REPORT_DETAILS = 10;

  useEffect(() => {
    if (!apiData) return;
    const reportDetails =
      apiData?.card === "Training"
        ? 1
        : apiData?.card === "lesson"
          ? 2
          : apiData?.card === "course"
            ? 3
            : apiData?.card === "safety"
              ? 4
              : apiData?.card === "hazard"
                ? 5
                : apiData?.reportDetails;
    const resolvedReportDetails =
      reportDetails ??
      (page === "trainingWithLowestParticipation" ||
      page === "TrainingWithLowestParticipation"
        ? TRAINING_WITH_LOWEST_PARTICIPATION_REPORT_DETAILS
        : undefined);
    if (resolvedReportDetails == null) return;
    getMoretDetails({
      startDate: getFormatedDate(apiData?.startDate),
      endDate: getFormatedDate(apiData?.endDate),
      divisionId:
        apiData?.divisionId === "AllDivision" ? 0 : apiData?.divisionId,
      reportDetails: resolvedReportDetails,
      page: 1,
      pageSize: PAGE_SIZE_500,
      trainingType: typeselectdata ?? [],
      isSendMail: false,
    });
  }, []);
  function dataClear() {
    dispatch(lmsReportAction.clearDashboardDetails());
  }

  useEffect(() => {
    if (getLmsDashboardReportDetails.status === "SUCCESS" && emailSendStatus) {
      toast.success("Data has been sent to your email successfully!");
    }
  }, [getLmsDashboardReportDetails]);

  useEffect(() => {
    if (Array.isArray(location?.state?.typeselectdata)) {
      setTypeselectdata(location.state.typeselectdata);
    }
  }, [location?.state?.typeselectdata]);

  return (
    <div>
      {getLmsDashboardReportDetails.isLoading && <Loader />}
      <DrillDown
        page={page}
        getLmsDashboardReportDetails={getLmsDashboardReportDetails}
        getMoretDetails={getMoretDetails}
        apiData={apiData}
        getLMSDashboardReport={getLMSDashboardReport}
        selectedCard={selectedCard}
        setselectedCard={setselectedCard}
        dataClear={dataClear}
        typeselectdata={typeselectdata}
        setTypeselectdata={setTypeselectdata}
      />
      <ToastContainer />
    </div>
  );
};

export default DrillDownContainer;
